module.exports = __webpack_public_path__ + "static/world.85150fb8.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/images/world.png
// module id = 502
// module chunks = 10 11